import Layout from '@/libs/components/Layout'
import { generateCertificateStyleVars } from '@/libs/functions/generateCssVars'
import { getUrlAllParams, getUrlParam } from '@/libs/functions/getValue'
import useCategorySet from '@/libs/hooks/useCategorySet'
import { Form, Input, Popup, Space, Toast } from 'antd-mobile'
import { useEffect, useState } from 'react'
import styles from './index.scss'
import goTo from '@/libs/functions/goTo'
import {
  authSendSms,
  getMemberInfo,
  triggerNodeOauth,
  authSendSmsVerif,
  getMemberInfoVerif,
  triggerNodeOauthVerif,
  getMemberInfoWithDesensitization,
} from '@/services'
import CountryCallPicker from '../components/CountryCallPicker'
import useLang from '@/libs/hooks/useLang'
import { trackEvent } from '@/libs/functions/track'
import getChannelBridgeApi, {
  historyBackWFallback,
} from '@/libs/functions/appAdapter'
import { getStorage } from '@/libs/functions/onStorage'

let timer: any = null
let btnCountDownTimer: any = null

const apis = {
  verification: {
    authSendSms: authSendSmsVerif,
    getMemberInfo: getMemberInfoVerif,
    triggerNodeOauth: triggerNodeOauthVerif,
  },
  normal: {
    authSendSms,
    getMemberInfo: getMemberInfoWithDesensitization,
    triggerNodeOauth,
  },
} as { [key: string]: any }

export default function oauth() {
  const { t } = useLang('prompt_util')
  const type = getUrlParam('type')
  const api = apis[type || 'normal']
  const redirect = getUrlParam('redirect')
  const triggerArea = getUrlParam('triggerArea')
  const { tenantCode, triggerNodeCode, triggerNode } = getUrlAllParams() as any
  const [termsModal, setTermsModal] = useState(false)
  const [termsInfo, setTermsInfo] = useState({
    buttonText: '',
    authContent: '',
  })
  const [loading, setLoading] = useState(false)
  const [checkClause, setCheckClause] = useState(false)
  const [form] = Form.useForm()
  const [userInfo, setUserInfo] = useState({
    userName: '',
    mobile: '',
    guestCode: '',
    countryCallPrefix: '',
  })
  const [userNameReadOnly, setUserNameReadOnly] = useState(false)
  const [userPhoneReadOnly, setUserPhoneReadOnly] = useState(false)
  const [userEmailReadOnly, setUserEmailReadOnly] = useState(false)

  const { categorySetting } = useCategorySet('AUTHORIZE', tenantCode)
  const [time, setTime] = useState(0)
  const [btnCountDownTime, setBtnCountDownTime] = useState(0)
  const { certificatePage, buttonStyle } = categorySetting
  const customTextStyle = generateCertificateStyleVars(certificatePage)
  const {
    pageTitle,
    pageInfo,
    privacy = true,
    banner = [],
    pageBackground,
    bgColor,
    backgroundImage,
    fields = [],
  } = certificatePage || {}

  const pageBackgroundStyle =
    pageBackground === 'color'
      ? bgColor
      : `url(${backgroundImage}) no-repeat center top  / cover`

  const { btnColor, delayTime = 0, borderRadius = 0 } = buttonStyle || {}
  const isNameVisible = fields.includes('name')
  const isPhoneVisible = fields.includes('phone')
  const isGusetCodeVisible = fields.includes('guestCode')
  const isEmailVisible = fields.includes('email')
  const sortAuthProtocols = (certificatePage?.authContents ?? []).sort(
    (a, b) => a.sort - b.sort,
  )

  useEffect(() => {
    api.getMemberInfo().then((res) => {
      setUserInfo(res)
      if (res.userName) {
        setUserNameReadOnly(true)
      }
      if (res.mobile) {
        setUserPhoneReadOnly(true)
      }
      if (res.email) {
        setUserEmailReadOnly(true)
      }
      form?.setFieldsValue(res)
    })
    timer && clearInterval(timer)
    btnCountDownTimer && clearInterval(btnCountDownTimer)
    return () => {
      timer && clearInterval(timer)
      btnCountDownTimer && clearInterval(btnCountDownTimer)
    }
  }, [])

  useEffect(() => {
    window?.dpTracker?.sendPage({
      publicParams: {
        page_name: '授权页',
      },
    })
    return () => {
      window?.dpTracker?.sendPageEnd()
    }
  }, [])

  const reportAuthClk = (
    component_name: string,
    extra?: { [key: string]: any },
  ) => {
    window?.dpTracker?.sendClk({
      eventData: {
        module_name: '授权条款',
        component_name,
        ...(extra || {}),
      },
    })
  }

  useEffect(() => {
    if (delayTime !== 0 && delayTime !== undefined) {
      setBtnCountDownTime(delayTime)
    }
  }, [delayTime])

  useEffect(() => {
    if (delayTime === 0 || delayTime === undefined) return
    if (btnCountDownTime === delayTime) {
      btnCountDownTimer = setInterval(
        () => setBtnCountDownTime((btnCountDownTime) => --btnCountDownTime),
        1000,
      )
    } else if (btnCountDownTime === -1) clearInterval(btnCountDownTimer)
  }, [btnCountDownTime, delayTime])

  useEffect(() => {
    if (time === 60) timer = setInterval(() => setTime((time) => --time), 1000)
    else if (time === 0) {
      clearInterval(timer)
    }
  }, [time])

  const handleOauth = async () => {
    reportAuthClk('同意授权', { is_ticked: checkClause ? 1 : 0 })
    if (btnCountDownTime > -1 && delayTime !== 0) {
      return
    }
    if (privacy && !checkClause) {
      Toast.show('请阅读并同意条款')
      return
    }
    const values = await form.validateFields()
    if (userNameReadOnly) {
      delete values.userName
    }

    if (userPhoneReadOnly) {
      delete values.mobile
      delete values.smsCode
      delete values.countryCallPrefix
    }
    if (userEmailReadOnly) {
      delete values.email
    }

    api
      .triggerNodeOauth({
        triggerNodeCode,
        triggerNode,
        triggerArea: triggerArea || 'before_entering',
        ...values,
      })
      .then(() => {
        Toast.show('授权成功')
        if (redirect) {
          goTo(decodeURIComponent(redirect), {
            type: 'replace',
          })
        } else {
          goTo(-1)
        }
      })

    try {
      trackEvent('OAUTH_DATA_VERIFY', {
        meta: {
          memberPersetInfo: JSON.stringify(userInfo ?? {}),
          submitFormData: JSON.stringify({
            triggerNodeCode,
            triggerNode,
            triggerArea: triggerArea || 'before_entering',
            ...values,
          }),
          fields: JSON.stringify(fields || []),
        },
      })
    } catch (err) {}
  }

  const goBack = () => {
    reportAuthClk('暂不同意')
    try {
      const channel = getStorage('channel')
      const { goBackWebview } = getChannelBridgeApi(channel)
      // 泉州银行强制回到 App
      if (channel === 'quanZhouBank' && goBackWebview) {
        goBackWebview?.()
      } else {
        // 回退失败则返回上一个app webview
        historyBackWFallback(() => goTo(-1), goBackWebview)
      }
    } catch (err) {
      goTo(-1)
    }
  }

  const handleClauseChange = () => {
    const nextChecked = !checkClause
    reportAuthClk('是否勾选', { is_ticked: nextChecked ? 1 : 0 })
    setCheckClause(nextChecked)
  }

  const getMemberSendSms = async () => {
    if (time > 0) return
    const { mobile, countryCallPrefix } = await form.validateFields([
      'mobile',
      'countryCallPrefix',
    ])
    await api.authSendSms({
      mobile,
      countryCallPrefix,
    })
    setTime(60)
  }

  const svgFill = btnColor

  return (
    <Layout title={pageTitle}>
      <div
        className={styles.authPage}
        style={{
          background: pageBackgroundStyle,
          ...customTextStyle,
        }}
      >
        <div className={styles.bgImageWrap}>
          <img className={styles.bgImage} src={banner?.[0]} alt="" />
        </div>
        <section className={styles.container}>
          <Form
            form={form}
            layout="horizontal"
            onFinish={async (values) => {
              setLoading(true)
            }}
            footer={
              <>
                <div
                  style={{
                    backgroundColor: btnColor,
                    borderRadius: `${borderRadius || 0}px`,
                  }}
                  className={`${styles.btn} ${styles.btnPrimary} ${
                    btnCountDownTime > -1 &&
                    delayTime !== 0 &&
                    styles.btnDisabled
                  }`}
                  onClick={handleOauth}
                >
                  {buttonStyle?.btnConfirmText || '同意授权'}
                  {delayTime === 0
                    ? ''
                    : btnCountDownTime > -1
                    ? `（${btnCountDownTime}s）`
                    : ''}
                </div>
                <div
                  style={{ borderRadius: `${borderRadius || 0}px` }}
                  onClick={goBack}
                  className={`${styles.btn} ${styles.btnDefault}`}
                >
                  {buttonStyle?.btnCancelText || '暂不同意授权'}
                </div>
              </>
            }
          >
            {isNameVisible && (
              <Form.Item
                className={styles.formItem}
                name="userName"
                label="姓名"
                rules={[
                  {
                    required: isNameVisible,
                    message: '请输入姓名',
                  },
                ]}
              >
                <Input
                  readOnly={userNameReadOnly}
                  clearable
                  placeholder="请输入姓名"
                />
              </Form.Item>
            )}
            {isPhoneVisible && (
              <>
                <Form.Item label="手机号" className={styles['form-item']}>
                  <Space>
                    <Form.Item
                      noStyle
                      name="countryCallPrefix"
                      initialValue={userInfo.countryCallPrefix || '+86'}
                    >
                      <CountryCallPicker readOnly={userPhoneReadOnly} />
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={(cur, prev) =>
                        cur.countryCallPrefix !== prev.countryCallPrefix
                      }
                      noStyle
                    >
                      {(form) => {
                        const { countryCallPrefix } = form.getFieldsValue()

                        return (
                          <Form.Item
                            name="mobile"
                            className={styles.formItem}
                            label=""
                            noStyle
                            rules={[
                              {
                                required: !userPhoneReadOnly,
                                message: '请输入手机号',
                              },
                              {
                                max: 11,
                              },
                              {
                                validator(rule, value) {
                                  if (userPhoneReadOnly) {
                                    return Promise.resolve()
                                  } else {
                                    if (
                                      !value ||
                                      (countryCallPrefix === '+86' &&
                                        !new RegExp('^[1][2-9][0-9]{9}$').test(
                                          value,
                                        ))
                                    ) {
                                      return Promise.reject(
                                        new Error(
                                          t(
                                            'mobileRuleMessage',
                                            '请输入正确的手机号码',
                                          ),
                                        ),
                                      )
                                    } else {
                                      return Promise.resolve()
                                    }
                                  }
                                },
                              },
                            ]}
                          >
                            <Input
                              style={{ width: '90%' }}
                              readOnly={userPhoneReadOnly}
                              clearable
                              placeholder="请输入手机号"
                            />
                          </Form.Item>
                        )
                      }}
                    </Form.Item>
                  </Space>
                </Form.Item>

                <Form.Item
                  hidden={userPhoneReadOnly}
                  name="smsCode"
                  extra={
                    <div
                      className={styles.getCode}
                      onClick={getMemberSendSms}
                      style={{
                        color: btnColor,
                      }}
                    >
                      {time === 0 ? '发送验证码' : `（${time}）`}
                    </div>
                  }
                  rules={[
                    {
                      required: !userPhoneReadOnly,
                      message: '请输入验证码',
                    },
                  ]}
                  label="验证码"
                >
                  <Input
                    type="number"
                    placeholder="请输入验证码"
                    clearable
                    onChange={(value) => {
                      form.setFieldsValue({
                        smsCode: value.slice(0, 4),
                      })
                    }}
                  />
                </Form.Item>
              </>
            )}
            {isGusetCodeVisible && (
              <Form.Item className={styles.formItem} label="客户编码">
                <Input
                  readOnly
                  value={userInfo?.guestCode}
                  clearable
                  placeholder=""
                />
              </Form.Item>
            )}
            {isEmailVisible && (
              <Form.Item
                name="email"
                className={styles.formItem}
                label="邮箱"
                rules={[
                  {
                    required: !userEmailReadOnly,
                    message: '请输入邮箱',
                  },
                  !userEmailReadOnly
                    ? {
                        type: 'email',
                        message: '请输入正确的邮箱',
                      }
                    : {},
                ]}
              >
                <Input
                  readOnly={userEmailReadOnly}
                  clearable
                  placeholder="请输入邮箱"
                />
              </Form.Item>
            )}
            <Form.Item className={styles.infoFormItem}>
              <p className={styles.info}>{pageInfo}</p>
            </Form.Item>
            {privacy && (
              <div className={styles.clauseWrap} onClick={handleClauseChange}>
                {checkClause ? (
                  <svg
                    width="10px"
                    height="10px"
                    viewBox="0 0 10 10"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                  >
                    <title>切片</title>
                    <g
                      id="嘉宾服务"
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                    >
                      <g
                        id="商业化中心用户端H5/用户登陆备份-2"
                        transform="translate(-30.000000, -390.000000)"
                      >
                        <g
                          id="编组"
                          transform="translate(10.000000, 199.000000)"
                        >
                          <g
                            id="编组"
                            transform="translate(20.000000, 191.000000)"
                          >
                            <rect
                              id="矩形"
                              fill={svgFill}
                              x="0"
                              y="0"
                              width="10"
                              height="10"
                              rx="2"
                            ></rect>
                            <path
                              d="M2.5,2 C2.77614237,2 3,2.22385763 3,2.5 L2.99913263,5.017 L7.49913263,5.01786947 C7.77527501,5.01786947 7.99913263,5.2417271 7.99913263,5.51786947 C7.99913263,5.79401185 7.77527501,6.01786947 7.49913263,6.01786947 L2.49913263,6.01786947 C2.22299026,6.01786947 1.99913263,5.79401185 1.99913263,5.51786947 C2.00002233,5.50551074 2,5.50275798 2,5.5 L2,2.5 C2,2.22385763 2.22385763,2 2.5,2 Z"
                              id="形状结合"
                              fill="#FFFFFF"
                              transform="translate(4.999133, 4.008935) rotate(-45.000000) translate(-4.999133, -4.008935) "
                            ></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                ) : (
                  <img
                    className={styles.checkClause}
                    src={require('@/assets/image/memberEquity/ico_select_normal.png')}
                  />
                )}
                <div className={styles.clause}>
                  {certificatePage?.shortTips || '你已阅读并同意'}
                  {sortAuthProtocols &&
                    sortAuthProtocols.map((i, index) => {
                      return (
                        <>
                          <span
                            style={{
                              color: btnColor,
                            }}
                            onClick={(e) => {
                              reportAuthClk('条款明细', {
                                regulation_name: i.buttonText,
                              })
                              setTermsModal(true)
                              setTermsInfo(i)
                              e.stopPropagation()
                              e.preventDefault()
                            }}
                          >
                            {i.buttonText}
                          </span>
                          {index < sortAuthProtocols.length - 1 ? '、' : ''}
                        </>
                      )
                    })}
                </div>
              </div>
            )}
          </Form>
        </section>
        <section className={styles.block}></section>
        <Popup
          showCloseButton
          visible={termsModal}
          onMaskClick={() => {
            setTermsModal(false)
          }}
          onClose={() => {
            setTermsModal(false)
          }}
          position="right"
          bodyStyle={{ width: '100vw' }}
        >
          <div className={styles.termsContentWrap}>
            <div className={styles.termsModalHeader}>
              {termsInfo.buttonText}
            </div>
            <p
              className={styles.termsModalContent}
              dangerouslySetInnerHTML={{ __html: termsInfo.authContent }}
            ></p>
          </div>
        </Popup>
      </div>
    </Layout>
  )
}
